import { render } from "./SubsidizePage.vue?vue&type=template&id=22e14232"
import script from "./SubsidizePage.vue?vue&type=script&lang=js"
export * from "./SubsidizePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__